import TableInput from 'components/main/screenExperimentWizard/TableInput';
import React, { useState } from 'react';
import UpdateIcon from 'Icons/CustomSelectUpdate.svg';
import DeleteIcon from 'Icons/CustomSelectDelete.svg';
import ApplyIcon from 'Icons/CommandPanel/Apply.svg';
import CloseIcon from 'Icons/CustomSelectClose.svg';

function TemplateOption({
  item,
  onClickCustomOption,
  onChangeVal,
  deleteTemplate,
  discardUpdateName,
}) {
  let tempVal = item.name;
  function saveTempVal(val) {
    tempVal = val;
  }
  const [updateDelete, setUpdateDelete] = useState(true);

  return (
    <div
      id="templateoption-wrapper"
      data-testid="templateoption-wrapper"
      className="custom-select-option"
    >
      <TableInput
        initialValue={item.name}
        className="custom-select-input"
        type="text"
        readOnly={updateDelete}
        customStyle={{
          flex: 8,
          border: updateDelete ? 'none' : '1px solid blue',
          background: '#ffffff',
          cursor: 'pointer',
          outline: 'none',
          fontSize: '16px',
          height: '30px',
        }}
        onClick={() => updateDelete && onClickCustomOption(item.name)}
        changeInputValue={saveTempVal}
      />
      {updateDelete ? (
        <div
          id="templateoption-editdelete-wrapper"
          data-testid="templateoption-editdelete-wrapper"
          style={{ flex: 2 }}
          className="custom-select-edit"
        >
          <img
            id="templateoption-edit-btn"
            data-testid="templateoption-edit-btn"
            src={UpdateIcon}
            style={{ flex: 1, cursor: 'pointer' }}
            onClick={() => setUpdateDelete(false)}
            className="custom-select-edit custom-edit-delete"
          />
          <img
            id="templateoption-delete-btn"
            data-testid="templateoption-delete-btn"
            src={DeleteIcon}
            style={{ flex: 1, cursor: 'pointer' }}
            onClick={() => deleteTemplate(item.name)}
            className="custom-select-delete custom-edit-delete"
          />
        </div>
      ) : (
        <div
          id="templateoption-applyclose-wrapper"
          data-testid="templateoption-applyclose-wrapper"
          style={{ flex: 2 }}
          className="custom-select-apply"
        >
          <img
            id="templateoption-close-btn"
            data-testid="templateoption-close-btn"
            src={CloseIcon}
            className="close-edit-name cursor-pointer"
            style={{ flex: 1, cursor: 'pointer' }}
            onClick={() => {
              discardUpdateName();
              setUpdateDelete(true);
            }}
          />
          <img
            id="templateoption-apply-btn"
            data-testid="templateoption-apply-btn"
            src={ApplyIcon}
            className="close-apply-name cursor-pointer"
            style={{ flex: 1, cursor: 'pointer' }}
            onClick={() => {
              onChangeVal(tempVal);
              setUpdateDelete(true);
            }}
          />
        </div>
      )}
      {}
    </div>
  );
}

export default TemplateOption;
